import * as RadixMenu from '@radix-ui/react-dropdown-menu';
import { cn } from '@/lib/cn';

export const Menu = RadixMenu.Root;
export const MenuTrigger = RadixMenu.Trigger;

export function MenuContent({
  children,
  align = 'end',
  side = 'bottom',
  className,
}: {
  children: React.ReactNode;
  align?: 'start' | 'center' | 'end';
  side?: 'top' | 'right' | 'bottom' | 'left';
  className?: string;
}) {
  return (
    <RadixMenu.Portal>
      <RadixMenu.Content
        align={align}
        side={side}
        sideOffset={6}
        className={cn(
          'z-50 min-w-[220px] rounded-lg border border-[color:var(--ts-border-soft)] bg-surface p-1 shadow-float',
          'data-[state=open]:anim-pop-in data-[state=closed]:anim-pop-out',
          className,
        )}
      >
        {children}
      </RadixMenu.Content>
    </RadixMenu.Portal>
  );
}

export function MenuItem({ children, className, ...props }: React.ComponentPropsWithoutRef<typeof RadixMenu.Item>) {
  return (
    <RadixMenu.Item
      className={cn(
        'flex h-9 cursor-pointer items-center gap-2 rounded-md px-2.5 text-base text-gray-3 outline-none',
        'transition-colors duration-150 ease-out',
        'data-[highlighted]:bg-[color:var(--ts-row-hover)] data-[highlighted]:text-primary',
        'data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
        className,
      )}
      {...props}
    >
      {children}
    </RadixMenu.Item>
  );
}

export function MenuLabel({ children }: { children: React.ReactNode }) {
  return <RadixMenu.Label className="px-2.5 py-1.5 text-xs text-muted-foreground">{children}</RadixMenu.Label>;
}

export function MenuSeparator() {
  return <RadixMenu.Separator className="my-1 h-px bg-[color:var(--ts-border)]" />;
}
